"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RemoveIcon = function RemoveIcon(_ref) {
  var visible = _ref.visible,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(visible ? 'animate-enter' : 'hidden', 'absolute w-[36px] h-[36px] z-[2] top-0 right-0 translate-x-1/2 -translate-y-1/2 rounded-full bg-white', className),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "close-bubble",
    size: 36
  }));
};
var _default = RemoveIcon;
exports.default = _default;